import {newPricingDetails} from '../../utils/constants/signalmanConstants';

class NewPricingDetailsTest {
  constructor() {
    this.flag = newPricingDetails;
    this.fireMetrics();
    this.dataLayerPush();
  }

  fireMetrics() {
    return CustomInk.Metrics.fireEvent(
      'testing',
      '2024 05 01 catalog new pricing details',
      `2024 05 01 catalog new pricing details ${this.flag}`
    );
  }

  dataLayerPush() {
    return window.dataLayer.push({
      event: 'ab_test_group',
      ab_test_name: 'price grid on plp hover',
      ab_test_location: 'plp catalog',
      ab_test_group: this.flag
    });
  }
}

jQuery(
  () => (ProductCatalog.NewPricingDetailsTest = new NewPricingDetailsTest())
);
